import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-pagination-v2',
  standalone: true,
  imports: [CommonModule,PaginatorModule],
  templateUrl: './pagination-v2.component.html',
  styleUrls: ['./pagination-v2.component.scss']
})
export class PaginationV2Component implements OnChanges {
  @Input() getAPI: string;
  @Input() APIService: any;
  @Input() filters: any;
  @Input() count: number;
  @Input() page: number = 0;
  @Input() rows: number = 5;
  @Input() id?: number;

  @Output() recordsEmitter = new EventEmitter<any>();
  @Output() loadingPage = new EventEmitter();
  first: number = 0;
  pageSizeOptions: number[] = [];

  get lang(): string {
    return localStorage.getItem('lang') || 'en';
  }

  private readonly defaultPageSizes = [5, 10, 12, 25, 50, 75];

  ngOnInit(): void {
      this.updatePageSizeOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters'] && !changes['filters'].firstChange) {
      this.first = 0;
      this.page = 0;
      this.fetchRecords(this.page, this.rows);
    }
  }




  private updatePageSizeOptions(): void {
    this.pageSizeOptions = this.defaultPageSizes.filter(size => size <= this.count);
    const maxPageSize = Math.min(100, this.count);
    if (!this.pageSizeOptions.includes(maxPageSize)) {
      this.pageSizeOptions.push(maxPageSize);
    }
    if (!this.pageSizeOptions.includes(5)) {
      this.pageSizeOptions.unshift(5);
    }
  }



  private fetchRecords(page: number, size: number,filters = '', id?: number): void {
    if (this.getAPI) {
      this.loadingPage.emit(true);
        this.APIService[this.getAPI](page, size, filters, id ? id : undefined).subscribe({
          next: (res: any) => {
            this.recordsEmitter.emit(res);
            this.updatePageSizeOptions();
            this.loadingPage.emit(false);
          },
          error: () => this.loadingPage.emit(false),
        });
    }
  }

  onPageChange(event: any): void {
    this.page = event.page;
    this.rows = event.rows;
    this.loadingPage.emit(true)
    this.fetchRecords(this.page, this.rows,this.filters, this.id ? this.id : undefined);
  }
}

